'use strict';

angular.module('atex.dam').directive('damThumbGridElement', function() {
  var linkFn = function(scope, element, attrs) {
  };
  return {
    scope : false,
    restrict : 'A',
    link : linkFn
  };
});

angular.module('atex.dam').directive('damThumbExpander', function() {
  var linkFn = function(scope, element, attrs) {
    scope.$on('keydown', function(msg, code) {
      if (code === 39) {// arrow key right
        scope.goFwd();
      } else if (code === 37) {// arrow key left
        scope.goPrw();
      }
    });
  };
  return {
    scope : false,
    restrict : 'A',
    link : linkFn
  };
});

angular.module('atex.dam').directive('damThumbJustifiedGallery', function($timeout) {
  var linkFn = function(scope, element, attrs) {
    scope.$on('dam:justifyThumbs', function(msg, redoFullJustification) {
      var margin = parseInt(attrs.damThumbMargin) > 0 ? parseInt(attrs.damThumbMargin) : 4;
      var lastRowTop;
      var availablewidth = element.width();
      var images = angular.element.find('.dam-tojustify');
      var currentRow = [];
      $.each(images, function (index, image) {
        var actualElem = $(this);
        if (actualElem.is(":visible") && actualElem.attr("id") !== 'expanderImg') {
          if (!redoFullJustification && actualElem.data('justOk')>0) {
            return;
          }
          var actualTop = actualElem.offset().top;
          if (lastRowTop===undefined || actualTop>lastRowTop+20) {
            // Check if this item should be added to the previous row
            var firstItemWidth = actualElem.width();
            var _currRowLen = currentRow.length;
            if (_currRowLen>0) {
              // Perform width adjust
              var left = currentRow[0].offset().left - (margin*3+1);
              var right = currentRow[currentRow.length-1].offset().left + currentRow[currentRow.length-1].width() + (margin*3+1);
              var diff = availablewidth - (right - left);
              var singDiff = 0;
              var alreadyParsed = false;
              if (diff > firstItemWidth/2) {
                alreadyParsed = true;
                currentRow.push(actualElem);
                singDiff = -((firstItemWidth+(margin*3+2)-diff) / currentRow.length);
              } else {
                lastRowTop = actualTop;
                singDiff = diff / currentRow.length;
              }
              $.each(currentRow, function(i) {
                var actualRowElem = $(this);
                actualRowElem.css('width', actualRowElem.width() + singDiff);
                actualRowElem.data('justOk', 1);
              });
              // END Perform width adjust! NOW reset currentRow
              currentRow = [];
              if (!alreadyParsed) {
                currentRow.push(actualElem);
              }
            } else {
              lastRowTop = actualTop;
              currentRow.push(actualElem);
            }
          } else {
            currentRow.push(actualElem);
          }
        }
      });
    });
  };
  return {
    scope : false,
    restrict : 'A',
    link : linkFn
  };
});
